<div class="sidebar-header">{{headerContent}}</div>
<form class="standard-form" (ngSubmit)="onSubmit()" [formGroup]="objectiveForm">
  <div class="input-error-wrap sans-margin">
    <p-dropdown auto="strat-theme-dropdown" class="standard-input block" id="objectivePriority"
                name="objective priority" [autoWidth]="false"
                [options]="prioritySelectItems" [formControl]="priority">
    </p-dropdown>
    <app-error-msg [control]="priority" [show]="priority.invalid && priority.touched && priority.dirty">
    </app-error-msg>
  </div>
  <label class="standard-label" for="objectiveDescription">Objective</label>
  <div class="input-error-wrap sans-margin">
    <textarea auto="obj-descrip-field" pInputTextarea class="text-area" id="objectiveDescription"
              name="objective description" placeholder="Enter Objective here"
              [formControl]="text" [maxlength]="MAX_TEXT_LENGTH">
    </textarea>
    <div class="remaining-msg">Remaining: {{textRemainingCharacters}}</div>
    <app-error-msg [control]="text" [show]="text.invalid && text.touched && tag.dirty"></app-error-msg>
  </div>
  <label class="standard-label" for="priorityTag">Select a Tag</label>
  <div class="input-error-wrap sans-margin">
    <p-dropdown auto="obj-tag-drop" class="standard-input block" id="priorityTag" name="priority tag"
                [autoWidth]="false" [options]="tagSelectItems" [formControl]="tag">
    </p-dropdown>
    <app-error-msg [control]="tag" [show]="tag.invalid && tag.touched && tag.dirty"></app-error-msg>
  </div>
  <div class="button-row">
    <button auto="obj-cancel-btn" class="btn btn-alt left-btn" type="button" (click)="onCancel()">Cancel</button>
    <button auto="obj-save-btn" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
</form>
